import styled from 'styled-components'

const StyledPageContent = styled.div`
  padding: 1rem 1.5rem;
`

export default StyledPageContent
